import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { getIntakeReceipt } from '../../services/api';
const PdfCanvas = lazy(() => import('./PdfCanvas'));

export default function ReceiptViewer({ entryId, file, open, onClose }) {
  const [source, setSource] = useState(null);
  const [error, setError] = useState('');
  const [zoom, setZoom] = useState(1);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!open) return;
    let alive = true;
    let objectURL;
    setSource(null); setError(''); setZoom(1);
    if (file) {
      objectURL = URL.createObjectURL(file);
      setSource({ url: objectURL, download_url: objectURL, filename: file.name, content_type: file.type });
    } else {
      getIntakeReceipt(entryId).then(({ data }) => { if (alive) setSource(data); })
        .catch(() => { if (alive) setError('Could not open the original. Try refreshing its temporary link.'); });
    }
    return () => { alive = false; if (objectURL) URL.revokeObjectURL(objectURL); };
  }, [open, entryId, file, reload]);
  return <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
    <DialogTitle sx={{ overflowWrap: 'anywhere' }}>{source?.filename || 'Original receipt'}</DialogTitle>
    <DialogContent sx={{ minHeight: '55vh', p: 1 }}>
      {error && <Alert severity="error">{error}</Alert>}
      {!source && !error && <CircularProgress aria-label="Opening original" />}
      {source && (source.content_type === 'application/pdf'
        ? <Suspense fallback={<CircularProgress aria-label="Opening PDF renderer" />}><PdfCanvas key={reload} entryId={entryId} file={file} /></Suspense>
        : <Box sx={{ overflow: 'auto', height: '65vh' }}><Box component="img" alt="Original uploaded receipt" src={source.url}
          onError={() => setError('The temporary link may have expired. Refresh to reopen the original.')}
          sx={{ width: `${zoom * 100}%`, maxWidth: 'none', display: 'block' }} /></Box>)}
    </DialogContent>
    <DialogActions sx={{ flexWrap: 'wrap' }}><Stack direction="row" flexWrap="wrap" gap={1}>
      {source?.content_type !== 'application/pdf' && <><Button onClick={() => setZoom(z => Math.max(0.5, z - 0.5))}>Zoom out</Button>
        <Button onClick={() => setZoom(z => Math.min(5, z + 0.5))}>Zoom in</Button></>}
      {!file && <Button onClick={() => setReload(r => r + 1)}>Refresh link</Button>}
      {source && <Button component="a" href={source.download_url} download={source.filename} target="_blank" rel="noopener noreferrer">Download original</Button>}
      <Button onClick={onClose}>Close</Button>
    </Stack></DialogActions>
  </Dialog>;
}
